import React, { useEffect, useState } from 'react'
import "../../styles/profileStyles/myProfilePosts.css";
import ForumPost from '../../components/ForumPost';
import { useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';

export default function MyProfilePosts() {
    const [cardDatas, setCardDatas] = useState([]);

    const { username: targetUsername } = useParams();

    // const cardDatas = {
    //     success: true,
    //     posts: [
    //         {
    //             id: 1,
    //             username: "tippmester123",
    //             profile_picture: "https://randomuser.me/api/portraits/men/32.jpg",
    //             text: "Erre a szelvényre gondoltam ma 🔥",
    //             created_at: "2 órája",
    //             images: [
    //                 "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e",
    //                 "https://images.unsplash.com/photo-1517649763962-0c623066013b"
    //             ],
    //             likes: 21,
    //             comments: [
    //                 {
    //                     id: 1,
    //                     username: "UserOne",
    //                     profile_picture: "https://randomuser.me/api/portraits/women/44.jpg",
    //                     comment: "Ez nagyon erősnek tűnik 👀",
    //                     created_at: "1 órája",
    //                     replies: [
    //                         {
    //                             id: 2,
    //                             username: "ProTipper",
    //                             profile_picture: "https://randomuser.me/api/portraits/men/12.jpg",
    //                             comment: "Én is rakom!",
    //                             created_at: "50 perce",
    //                             replies: []
    //                         }
    //                     ]
    //                 }
    //             ]
    //         },

    //         {
    //             id: 2,
    //             username: "ProTipper",
    //             profile_picture: "https://randomuser.me/api/portraits/men/12.jpg",
    //             text: "Mai meccsek közül ez a kedvencem ⚽",
    //             created_at: "5 órája",
    //             images: [
    //                 "https://images.unsplash.com/photo-1508098682722-e99c43a406b2"
    //             ],
    //             likes: 45,
    //             comments: [
    //                 {
    //                     id: 3,
    //                     username: "AnotherUser",
    //                     profile_picture: "https://randomuser.me/api/portraits/women/22.jpg",
    //                     comment: "Szerintem is sima lesz",
    //                     created_at: "3 órája",
    //                     replies: []
    //                 }
    //             ]
    //         },

    //         {
    //             id: 3,
    //             username: "FootballKing",
    //             profile_picture: "https://randomuser.me/api/portraits/men/55.jpg",
    //             text: "Mit szóltok ehhez a kötéshez?",
    //             created_at: "1 napja",
    //             images: [],
    //             likes: 12,
    //             comments: []
    //         }
    //     ]
    // };

    useEffect(() => {
        fetch(`https://focifanatik.hu/api/forumPage/forumPostsByUserId.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    setCardDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    if (!cardDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }

    return (
        <>
            <div className='myProfilePostsPage-topProfileBar'>

                <h1><i class="bi bi-bookmarks"></i></h1>
                <h1>Posztok</h1>

            </div>

            {/* TARTALOM */}
            <div className='myProfilePosts-content'>
                <div className='myProfilePostsGrid'>

                    {cardDatas && cardDatas.map((post) => (
                        <ForumPost
                            key={post.id}
                            id={post.id}
                            name={post.username}
                            timeAgo={post.timeAgo}
                            text={post.text}
                            images={post.images}
                            isLiked={post.isLiked}
                            likes={post.like_count}
                            commentsCount={post.comments.length}
                            comments={post.comments}
                        />
                    ))}


                </div>
            </div>


        </>
    )
}
